module.exports = __webpack_public_path__ + "img/密蒙花.e725f8cc.jpg";